import { Component } from '@angular/core';
import {PanelComponent} from '../../../../panel/panel.component';

@Component({
  selector: 'app-storage',
  imports: [
    PanelComponent
  ],
  templateUrl: './storage.component.html',
  styleUrl: './storage.component.css',
})
export class StorageComponent {

}
